module.exports = __webpack_public_path__ + "static/media/ticketing-bg.8b4a2735.jpg";